import type { TDocumentoAnexado } from '../types'

const pesoPorSituacao: Record<TDocumentoAnexado['status'], number> = {
  uploading: 0,
  error: 1,
  success: 2,
  recovered: 3,
}

export const compararDocumentosPorSituacao = (documento: TDocumentoAnexado, outroDocumento: TDocumentoAnexado) => {
  const diferencaDeSituacao = pesoPorSituacao[documento.status] - pesoPorSituacao[outroDocumento.status]
  if (diferencaDeSituacao !== 0) return diferencaDeSituacao

  if (!documento.dataEnvio) return outroDocumento.dataEnvio ? 1 : 0
  if (!outroDocumento.dataEnvio) return -1

  return documento.dataEnvio.localeCompare(outroDocumento.dataEnvio)
}
